import { CompStructure } from '@wix/document-services-types';
import { FedopsInteraction } from '../types';

export interface ImageGenerator {
  getImages: (
    sectionType: string,
    structure: CompStructure,
    imageGenerationParams: ImageGenerationParams,
  ) => Promise<ImagesMap | undefined>;
}

export interface ImageGeneratorOptions {
  interactionStarted: FedopsInteraction;
  interactionEnded: FedopsInteraction;
}

export type AspectRatio =
  | '1:1'
  | '2:3'
  | '3:2'
  | '4:5'
  | '5:4'
  | '9:16'
  | '16:9'
  | '9:21'
  | '21:9';

export interface ImageResolution {
  height?: number;
  width?: number;
}

export interface ImageDetails extends ImageResolution {
  fieldRole?: string;
  localUri?: string;
  staticUri?: string;
  displayName?: string;
  promptKey?: string;
  aspectRatio?: AspectRatio;
}

// This type alias is temporar
// Please change to a proper interface when support of imageDescription will be added
export type ImageDescription = object;

export type ImagesMap = Map<string, ImageDetails>;

export type PromptsData = Record<string, string>;

export enum DefaultSectionName {
  WELCOME = 'Welcome',
  ABOUT = 'About',
  GALLERY = 'Gallery',
  INSTAGRAM = 'Instagram',
  GENERAL = 'General',
}

export enum AbstractSectionName {
  ABSTRACT = 'Abstract',
}

export enum FIELD_ROLES {
  CROPTYPE_PORTRAIT = 'CROPTYPE_PORTRAIT',
  CROPTYPE_LANDSCAPE = 'CROPTYPE_LANDSCAPE',
  CROPTYPE_ABSTRACT = 'CROPTYPE_ABSTRACT',
  ABSTRACT = 'abstract',
}

export type SectionName = DefaultSectionName | AbstractSectionName;

export interface EventData<Type = string, Payload = { [key: string]: string }> {
  type: Type;
  payload: Payload;
}

export type GenerationEventData =
  | EventData<'onBunchGenerationStart', { amount: string; bunch: string }>
  | EventData<'onBunchGenerationSuccess', { amount: string; bunch: string }>
  | EventData<'onSingleGenerationStart', { id: string; bunch: string }>
  | EventData<
      'onSingleGenerationSuccess',
      { id: string; bunch: string; details: string }
    >
  | EventData<
      'onSingleGenerationError',
      { id: string; bunch: string; errn: string }
    >;

export type GenerationEventHandler = (eventData: GenerationEventData) => void;

export type UploadEventData =
  | EventData<'onBunchUploadStart', { amount: string; bunch: string }>
  | EventData<'onBunchUploadSuccess', { amount: string; bunch: string }>
  | EventData<'onSingleUploadStart', { bunch: string; compId: string }>
  | EventData<
      'onSingleUploadSuccess',
      { bunch: string; compId: string; imageUrl: string }
    >;

export type UploadEventHandler = (eventData: UploadEventData) => void;

export interface ImageGenerationParams {
  msId: string;
  msInstance: string;
  businessTerm: string;
  siteDescription?: string;
  onGenerationEvent?: GenerationEventHandler;
}

export type UriData = Map<string, string>;

export type UploadImagesDetails = [compId: string, imageDetails: ImageDetails];
